import { useLocation, useSearchParams } from "react-router";

import "../settings/validators";
import HelpDialog from "./HelpDialog";
import NavigationMenu from "./NavigationMenu/NavigationMenu";

import CookieDialog from './CookieDialog';

import { Outlet } from "react-router";
import { AuthTimeout } from "./Authentication/AuthTimeout";
import { Helmet } from "./Helmet";
import { useSettingsContext } from "./Settings/hooks/useSettingsContext";
import AnalyticsProvider from "./Analytics";

const SHOW_NAVIGATION_MENU_KEY = "showNavigationMenu";

const RootPage = () => {
  const Settings = useSettingsContext();
  const {pathname} = useLocation();
  const [searchParams] = useSearchParams();

  const showNavigationMenu = searchParams.get(SHOW_NAVIGATION_MENU_KEY)?.toLowerCase() !== "false";

  return pathname !== '/omipComponent' ?
    <>
      <AuthTimeout />
      {showNavigationMenu && <NavigationMenu />}

      <section id="app">
        <Helmet />
        <Outlet />
        { Settings?.helpDialog?.enabled && (
          <HelpDialog />
        )}
        <AnalyticsProvider />
        <CookieDialog />
      </section>
    </>
  :
    <Outlet />
};

export default RootPage;

